export default __webpack_public_path__ + "static/media/menu_buy_icon.0b0ea767.svg";